import { render, staticRenderFns } from "./PayGrades.vue?vue&type=template&id=087a8786"
import script from "./PayGrades.vue?vue&type=script&lang=js"
export * from "./PayGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports